import Vue from 'vue'
import App from './App.vue'
import router from './router'
import '@fortawesome/fontawesome-free/css/all.css'
import VeeValidate from 'vee-validate';
import { VueSpinners } from '@saeris/vue-spinners'

Vue.use(VeeValidate)
Vue.use(VueSpinners)

Vue.config.productionTip = false

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
